import { useState } from "react";
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  ListSubheader,
  TextField,
  Typography,
} from "@mui/material";
import SearchOffIcon from "@mui/icons-material/SearchOff";
import { useAppSelector } from "common/hooks";
import { NODE_TYPES } from "common/constants/enums";

const SearchableSelect = ({
  label = "Field ID *",
  name = "id",
  value,
  onChange,
  required = true,
  options,
}: any) => {
  const { nodes } = useAppSelector((state) => state.nodes.json);
  const [search, setSearch] = useState("");
  let filteredOptions: any = [];
  const OUTPUT_KEYS = [
    "income_limit_flag",
    "initial_household_size",
    "adjusted_household_size",
    "js_initial_household_size",
    "js_adjusted_household_size",
    "total_primary_income",
    "total_house_income",
    "assets_usc_total",
    "assets_immigrant_total",
    "assets_864a_total",
    "all_primary_assets",
    "js_total_primary_income",
    "js_assets_usc_total",
    "js_864a_assets_total",
    "js_primary_assets",
    "js_primary_income",
    "usci_asset_total",
  ];
  if (options) {
    filteredOptions = options
      ?.filter((o: any) => `${o?.label}`.toLowerCase().includes(search.toLowerCase()))
      .map((o: any) => (
        <MenuItem key={o.value} value={o.value}>
          {o.label}
        </MenuItem>
      ));
  } else {
    const menuItems = ["persona", ...nodes, ...OUTPUT_KEYS]
      ?.filter((n: any) =>
        typeof n === "string"
          ? `${n} (static)`.toLowerCase().includes(search.toLowerCase())
          : n?.data?.nodeType === NODE_TYPES.question &&
            `${n?.id}: ${
              n?.data?.properties?.title?.ifValue || n?.data?.properties?.title?.elseValue
            }`
              .toLowerCase()
              .includes(search.toLowerCase())
      )
      .map((n: any) =>
        typeof n === "string" ? (
          <MenuItem
            key={n}
            value={n}
            sx={{ display: "block", textOverflow: "ellipsis", maxWidth: 500, overflow: "hidden" }}
          >
            <b style={{ marginRight: 5 }}>{n}</b>{" "}
            <Typography variant="caption" color="textDisabled">
              (Static)
            </Typography>
          </MenuItem>
        ) : (
          <MenuItem
            key={n.id}
            value={n.id}
            sx={{ display: "block", textOverflow: "ellipsis", maxWidth: 500, overflow: "hidden" }}
          >
            <b style={{ marginRight: 5 }}>{n.id}:</b>{" "}
            {n?.data?.properties?.title?.ifValue || n?.data?.properties?.title?.elseValue}
          </MenuItem>
        )
      );
    filteredOptions = menuItems;
  }

  return (
    <FormControl fullWidth margin="dense">
      <InputLabel id={`${name}-label`}>{label}</InputLabel>
      <Select
        {...{
          name,
          value,
          label,
          onChange,
          MenuProps: { autoFocus: false },
          required,
          labelId: `${name}-label`,
        }}
      >
        {/* Search Input */}
        <ListSubheader>
          <TextField
            fullWidth
            placeholder="Search..."
            autoFocus
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            onKeyDown={(e) => e.stopPropagation()}
            onMouseDown={(e) => e.stopPropagation()}
            variant="standard"
            sx={{ py: "8px" }}
          />
        </ListSubheader>

        {/* Options */}
        {filteredOptions?.length ? (
          filteredOptions
        ) : (
          <ListSubheader sx={{ textAlign: "center", py: 2 }}>
            <SearchOffIcon sx={{ fontSize: "50px", display: "block", mx: "auto", mb: -2 }} />
            No Option Found
          </ListSubheader>
        )}
      </Select>
    </FormControl>
  );
};

export default SearchableSelect;
